module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-timetal__container",
    class: {
      'd-timetal__container__width': !_vm.isShowSubjects
    }
  }, [_c('div', {
    staticClass: "d-guides"
  }, [_c('StilGuides', {
    attrs: {
      "video-id": _vm.videoGuideId,
      "textForLink": _vm.videoGuideText
    }
  }), _vm._v(" "), (_vm.isShowSubjects) ? _c('p', {
    staticClass: "italic"
  }, [_c('b', [_vm._v("Bemærk:")]), _vm._v(" Opret, slet eller redigere fag påvirker kun\n      indberetningsdata'en - ikke i resten af Docendo")]) : _vm._e()], 1), _vm._v(" "), _c('table', {
    staticClass: "d-table",
    class: {
      'd-table__subjects': _vm.isShowSubjects
    }
  }, [(!_vm.isShowSubjects) ? _c('thead', [_c('tr', {
    staticClass: "tr--one"
  }, [_c('th', [_vm._v("Klasse")]), _vm._v(" "), _c('th', [_vm._v("Klassetrin")]), _vm._v(" "), _c('th', [_vm._v("Spor")]), _vm._v(" "), _c('th', [_c('div', {
    staticClass: "th__title-and-button"
  }, [_vm._v("\n          Klassetype\n        "), _c('button', {
    on: {
      "click": _vm.setIsModalCreateGrade
    }
  }, [_vm._v("Opret klasse")])])])])]) : _vm._e(), _vm._v(" "), _c('tbody', [_vm._l((_vm.klasserMedProps), function(klasse) {
    return [_c('tr', {
      staticClass: "tr--one pos-relative"
    }, [_c('td', {
      staticClass: "grade-name"
    }, [(!_vm.isShowSubjects) ? _c('div', {
      staticClass: "hint--top-right d-hidden__dropdown",
      attrs: {
        "aria-label": "Slet klasse og fag fra indberetningen"
      }
    }, [_c('button', {
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      on: {
        "click": function($event) {
          return _vm.setTheDeleteGrade(klasse)
        }
      }
    }, [_c('span', {
      staticClass: "icon-bin"
    })])]) : _vm._e(), _vm._v("\n          " + _vm._s(klasse.klassebetegnelse) + "\n          "), (_vm.isShowSubjects) ? _c('button', {
      staticClass: "klasse__create__btn",
      on: {
        "click": function($event) {
          _vm.theCreateSubject = klasse
        }
      }
    }, [_vm._v("\n            Opret fag\n          ")]) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
      staticClass: "d-select__small",
      domProps: {
        "value": klasse.klassetrin
      },
      on: {
        "change": function($event) {
          return _vm.updateStilKlasse(klasse, 'klassetrin', $event.target.value)
        }
      }
    }, _vm._l((_vm.klassetrin), function(standardKlasse) {
      return _c('option', {
        key: standardKlasse
      }, [_vm._v("\n              " + _vm._s(standardKlasse) + "\n            ")])
    }), 0) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('input', {
      staticClass: "d-input__small",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": klasse.spor
      },
      on: {
        "blur": function($event) {
          return _vm.updateStilKlasse(klasse, 'spor', $event.target.value, $event.target)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(!_vm.isShowSubjects) ? _c('select', {
      staticClass: "d-select__small",
      domProps: {
        "value": klasse.klasse_type
      },
      on: {
        "change": function($event) {
          return _vm.updateStilKlasse(klasse, 'klasse_type', $event.target.value)
        }
      }
    }, _vm._l((_vm.klasseTyper), function(klasseType, key) {
      return _c('option', {
        key: key,
        domProps: {
          "value": key
        }
      }, [_vm._v("\n              " + _vm._s(klasseType) + "\n            ")])
    }), 0) : _vm._e()])]), _vm._v(" "), (_vm.isShowSubjects) ? [_c('tr', {
      staticClass: "tr__header"
    }, [_c('td', [_vm._v("Fag")]), _vm._v(" "), _c('td', [_vm._v("Fagkode")]), _vm._v(" "), _c('td', [_vm._v("Klassetimer")]), _vm._v(" "), _c('td', [_vm._v("Underviser(e)")])]), _vm._v(" "), _vm._l((klasse.fag), function(fag) {
      return _c('tr', {
        key: fag.fag_id,
        staticClass: "tr__two"
      }, [_c('td', [_c('div', {
        staticClass: "hint--top-right fag-delete-bin",
        attrs: {
          "aria-label": "Slet fra indberetningen"
        }
      }, [_c('button', {
        staticClass: "icon__bg-circle icon__bg-circle--danger",
        on: {
          "click": function($event) {
            return _vm.setTheDeleteSubject(klasse, fag)
          }
        }
      }, [_c('span', {
        staticClass: "icon-bin"
      })])]), _vm._v("\n            " + _vm._s(fag.fag_navn) + "\n          ")]), _vm._v(" "), _c('td', [_c('select', {
        staticClass: "d-select__small",
        domProps: {
          "value": fag.fagkode
        },
        on: {
          "change": function($event) {
            return _vm.updateStilKlasseFag(klasse, fag, 'fagkode', $event.target.value)
          }
        }
      }, _vm._l((_vm.standardSubjects), function(fag) {
        return _c('option', {
          domProps: {
            "value": fag.fagkode
          }
        }, [_vm._v("\n                " + _vm._s(fag.fagkode) + ": " + _vm._s(fag.name) + "\n              ")])
      }), 0)]), _vm._v(" "), _c('td', [_c('input', {
        staticClass: "d-input__small",
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": fag.klokketimer
        },
        on: {
          "focus": function($event) {
            return $event.target.select()
          },
          "keyup": function($event) {
            if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
          },
          "blur": function($event) {
            _vm.updateStilKlasseFag(klasse, fag, 'klokketimer', $event.target.value, $event.target)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('div', {
        staticStyle: {
          "width": "400px"
        },
        on: {
          "click": function($event) {
            _vm.theEditTeacher = fag.fag_id
          }
        }
      }, [(fag.v_is_the_edit_teacher) ? _c('DSelect', {
        attrs: {
          "items": _vm.users,
          "itemsSelected": fag.laerere,
          "usersSSNHash": _vm.usersSSNHash
        },
        on: {
          "update": function($event) {
            _vm.updateStilKlasseFag(klasse, fag, 'laerere', $event)
          },
          "close": function($event) {
            _vm.theEditTeacher = null
          }
        }
      }) : _c('ul', {
        staticClass: "d-select__container",
        class: {
          'd-select__container--empty': fag.laerere.length < 1
        }
      }, [(fag.laerere.length < 1) ? _c('li', {
        staticClass: "d-select__container__add"
      }, [_vm._v("\n                  Tilføj minimun en underviser\n                ")]) : _vm._e(), _vm._v(" "), _vm._l((fag.laerere), function(user) {
        return _c('li', {
          staticClass: "d-pill",
          class: {
            'd-pill--error': user.v_no_cpr
          }
        }, [_vm._v("\n                  " + _vm._s(user.v_name) + "\n                ")])
      })], 2)], 1)])])
    })] : _vm._e()]
  })], 2)]), _vm._v(" "), (_vm.theDeleteSubject || _vm.theDeleteGrade) ? _c('ModalConfirmation', {
    attrs: {
      "propLocale": "da",
      "showClose": false
    },
    on: {
      "close": _vm.closeModalConfirm,
      "confirm": _vm.confirmDelete
    }
  }) : _vm._e(), _vm._v(" "), (_vm.theCreateSubject) ? _c('KompetenceIndberetningKlasserFagForm', {
    attrs: {
      "theCreateSubject": _vm.theCreateSubject,
      "standardSubjects": _vm.standardSubjects
    },
    on: {
      "save": _vm.saveNewSubject,
      "close": function($event) {
        _vm.theCreateSubject = null
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalCreateGrade) ? _c('KompetenceIndberetningCreateKlasseModal', {
    on: {
      "save": _vm.saveNewGrade,
      "close": _vm.setIsModalCreateGrade
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-78ea03d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/KompetenceIndberetning/KompetenceIndberetningKlasser.vue
// module id = 1736
// module chunks = 1